export default {
  path: 'stacklets/create',
  name: 'stacklet/create',
  component: () => import('@/views/dashboard/stacklets/create/index.vue'),
};
